// Debounce and setEqualHeight functions (no changes needed)
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

window.addEventListener('DOMContentLoaded', function () {
  setEqualHeight('.shopBySkinConcern__content');

  window.addEventListener('resize', debounce(function () {
    setEqualHeight('.shopBySkinConcern__content');
  }, 250)); 
});

function setEqualHeight(selector) {
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;

  elements.forEach(function (element) {
    element.style.height = 'auto'; 
    var height = element.clientHeight;
    maxHeight = Math.max(maxHeight, height);
  });

  elements.forEach(function (element) {
    element.style.height = maxHeight + 'px';
  });
}


const splideConfigShopByConcern = {
perPage: 4,
perMove: 1,
gap: '32px',
pagination: false,
arrows: false,
updateOnMove: true,
breakpoints: {
  1120: {
    perPage: 2,
    perMove: 1,
    gap: '32px',
    padding: { right: '12.4rem' },
  },
  767: {
    perPage: 1,
    perMove: 1,
    gap: '20px',
    padding: { right: '20%' },
  },
  430: {
    perPage: 1,
    perMove: 1,
    gap: '20px',
    padding: { right: '30%' },
  },
},
};

let splideInstanceShopByConcern = null;

// Function to initialize Splide
function initSplide() {

if (splideInstanceShopByConcern) {
  splideInstanceShopByConcern.destroy(true);
  splideInstanceShopByConcern = null; // Clear the old instance
}

// Select the slider element
const sliderElement = document.querySelector('#shopByConcern');

// Only initialize if the slider element exists
if (sliderElement) {
  // Create the new instance
  const splide = new Splide(sliderElement, splideConfigShopByConcern);
  
  // Add overflow event handler
  splide.on('overflow', function(isOverflow) {
    const options = {
      arrows: isOverflow,
      pagination: isOverflow,
      drag: isOverflow
    };
    
    // Update the slider options
    splide.options = {...splide.options, ...options};
    
    // Refresh the slider to apply changes
    if (splide.initialized) {
      splide.refresh();
    }
  });
  
  splide.mount();

  splideInstanceShopByConcern = splide;
}
}


document.addEventListener('DOMContentLoaded', initSplide);
document.addEventListener('shopify:section:load', initSplide);